import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";

var Child = function Child(_ref) {
  var children = _ref.children,
      width = _ref.width;
  var getClassName = getClassNameFactory("Longform");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "child",
      modifiers: classNames({
        narrow: width === "narrow",
        wide: width === "wide",
        full: width === "full"
      })
    })
  }, children);
};

Child.propTypes = {
  /**
   * Child nodes to wrap in Child.
   */
  children: PropTypes.node,

  /**
   * Width of the component.
   */
  width: PropTypes.oneOf(["full", "narrow", "wide"])
};
Child.defaultProps = {
  width: "narrow"
};
Child.displayName = "Longform.Child";
export default Child;